<div
    class="title-s ttu is-flex"
    [class.content-center]="textAlign === 'center'"
    [class.content-start]="textAlign === 'left'"
    [class.content-end]="textAlign === 'right'"
>
    @if (!isHexadecimalColors) {
        <span>{{ selectedColor?.name | titlecase }}</span>
    }
    @if (isHexadecimalColors) {
        <span>{{ selectedColor?.name | translate }}</span>
    }
    @if (!isCustomizationColor) {
        <span class="pl-8 pr-8"> | </span>
        <span>Ref. {{ displayReference }}</span>
    }
</div>
